import _get from 'lodash/get'

export const checkIsPromoter = event => _get(event, 'self.role') === 'promoter'

export const checkIsLimitedStats = event => _get(event, 'self.role') === 'limited_stats'
